import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICommonFilterFormMeta {
    acquirerBank?: FormInputMeta;
    traderId: FormInputMeta;
    referenceNumber: FormInputMeta;
    holderNumber: FormInputMeta;
    source?: FormInputMeta;
    emitterBank?: FormInputMeta;
    processingDateFrom: FormInputMeta;
    processingDateTo: FormInputMeta;
    
    operationType: FormInputMeta;
    usage: FormInputMeta;
    transactionType: FormInputMeta;
    
    schema: any;
}

const commonFilterFormMeta = {} as ICommonFilterFormMeta;

commonFilterFormMeta.acquirerBank = {
    name: "acquirerBank",
    type: "select",
    label: "Banque Acquéreur",
    placeholder: "",
    validation: yup.string(),
};

commonFilterFormMeta.emitterBank = {
    name: "emitterBank",
    type: "select",
    label: "Banque Emetteur",
    placeholder: "",
    validation: yup.string(),
};

commonFilterFormMeta.traderId = {
    name: "traderId",
    type: "select",
    label: "Id Commerçant",
    placeholder: "",
    validation: yup.string(),
};

commonFilterFormMeta.referenceNumber = {
    name: "referenceNumber",
    type: "text",
    label: "Numéro Référence",
    placeholder: "Numéro Référence",
    validation: yup.string(),
};

commonFilterFormMeta.holderNumber = {
    name: "holderNumber",
    type: "text",
    label: "Numéro Porteur",
    placeholder: "Numéro Porteur",
    validation: yup.string(),
};

commonFilterFormMeta.source = {
    name: "source",
    type: "select",
    label: "Source",
    placeholder: "",
    validation: yup.string(),
};

commonFilterFormMeta.processingDateFrom = {
    name: "processingDateFrom",
    type: "date",
    label: "Date Traitement Du",
    placeholder: "",
    validation: yup.date(),
};

commonFilterFormMeta.processingDateTo = {
    name: "processingDateTo",
    type: "date",
    label: "Au",
    placeholder: "",
    validation: yup.date(),
};

commonFilterFormMeta.operationType = {
    name: "operationType",
    type: "select",
    label: "Type Opération",
    placeholder: "",
    validation: yup.string(),
};


commonFilterFormMeta.usage = {
    name: "usage",
    type: "select",
    label: "Usage",
    placeholder: "",
    validation: yup.string(),
};

commonFilterFormMeta.transactionType = {
    name: "transactionType",
    type: "select",
    label: "Type Transaction",
    placeholder: "",
    validation: yup.string(),
};

commonFilterFormMeta.schema = yup.object().shape(getValidationSchema(commonFilterFormMeta));

export default commonFilterFormMeta;